export default __webpack_public_path__ + "static/media/fluxo-arte-facil.aa280ba3.png";